// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .vue-treeselect__input-container input {\n  padding: 10px;\n}\n[dir] .vue-treeselect__control {\n  border-color: #ccc;\n}", ""]);
// Exports
module.exports = exports;
